import { AxiosError } from "axios";
import { ClientError } from "graphql-request";
import { getStatusCode } from "utils/auth";
import { HttpStatusCode } from "utils/constants/http.constants";
import { LayoutError } from "utils/helpers";

const handleError = ({
  error,
  messageTranslationKeys = {},
}: {
  error: Error | null;
  messageTranslationKeys?: Record<string, string>;
  errorMessageTranslationKey?: string;
}) => {
  if (!error) {
    return;
  }

  if (error instanceof AxiosError || error instanceof ClientError) {
    if (error.response) {
      const statusCode = getStatusCode(error) || 0;

      const messageTranslationKey = HttpStatusCode[statusCode]
        ? messageTranslationKeys?.[statusCode] || "genericError"
        : "unsupportedHttpStatus";

      throw new LayoutError({ messageTranslationKey, statusCode });
    } else {
      throw new LayoutError({ messageTranslationKey: "genericError" });
    }
  } else {
    throw error;
  }
};

export default handleError;
